<template>
    <div class="w-full h-full flex flex-col">
        <h1 class="text-brand text-lg font-extrabold mb-2 border-gray-200 border-b h-8 overflow-hidden">
            <span class="ml-4 whitespace-nowrap"><i class="fas fa-diagnoses mr-4"></i>Defects</span>
        </h1>
        <main class="overflow-hidden flex-1 place-content-center">
            <div v-if="package" class="flex flex-col text-gray-500 cursor-pointer" @click="go">
                <div class="w-full text-center text-5xl hover:text-brand" v-if="this.count" v-text="this.count"></div>
                <div class="w-full text-center text-5xl hover:text-brand" v-else-if="this.count === null" v-text="'?'"></div>
                <div class="place-content-center w-full" v-else>
                    <div class="flex flex-col text-gray-500">
                        <div class="w-full text-center font-bold text-md"><span><i
                            class="text-lg text-green-600 far fa-check mr-4"></i></span>No Open Defects
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>

import {Defect} from "@models";

export default {
    components: {},
    props: {
        dashboardData: Object,
        dashboardProps: Object,
    },
    data() {
        return {
            package: null,
            count: null,
        }
    },
    computed: {},
    methods: {
        go() {
            window.document.location = this.package._links.frontend.defects
        }
    },
    mounted() {
        this.package = this.dashboardProps.legacyPackage
        Defect.all(this.package.reference).then((result) => {
            this.count = result.filter((i) => i.open).length
        })
    }
}

</script>